import { useMemo, useState } from "react";
import { usePopper } from "react-popper";
export function useStepState() {
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles: popperStyles, attributes } = usePopper(referenceElement, popperElement, {
        placement: "bottom",
    });
    const styles = useMemo(() => ({ ...popperStyles, popper: { ...popperStyles.popper, marginTop: "40px" } }), []);
    return useMemo(() => ({
        referenceElement,
        setReferenceElement,
        popperElement,
        setPopperElement,
        attributes,
        styles,
    }), [referenceElement, setReferenceElement, popperElement, setPopperElement, attributes, styles]);
}
